/** Enlaces oficiales de redes sociales de Smile Up */
export const CLINIC_SOCIAL_LINKS = [
  {
    id: 'instagram',
    href: 'https://www.instagram.com/dr.germanpaniura.ortodoncia/',
    iconClass: 'fa-brands fa-instagram',
    labelKey: 'topbar.socialInstagram',
  },
  {
    id: 'tiktok',
    href: 'https://www.tiktok.com/@j.germanpaniura',
    iconClass: 'fa-brands fa-tiktok',
    labelKey: 'topbar.socialTiktok',
  },
  {
    id: 'youtube',
    href: 'https://www.youtube.com/@smileupcusco',
    iconClass: 'fa-brands fa-youtube',
    labelKey: 'topbar.socialYoutube',
  },
];
